module.exports = __webpack_public_path__ + "static/media/final-07.1e844b10.svg";